import { FC, ReactNode } from 'react'

const LogoIcon: FC = (): ReactNode => {
    return (
        <svg
            width='32'
            viewBox='0 0 311 311'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g clipPath='url(#clip0_1_748)'>
                <path d='M0.5 117.057H18.9524V135.51H0.5V117.057Z' fill='#EBEBEB' />

                <path d='M0.5 58.625H18.9524V77.0774H0.5V58.625Z' fill='#EBEBEB' />

                <path
                    d='M58.9325 58.625H77.3849V77.0774H58.9325V58.625Z'
                    fill='#EBEBEB'
                />

                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M122.77 58.625H194.25V130.105L71.9803 252.375H0.5V180.895L122.77 58.625ZM130.413 77.0774L32.0002 175.49H77.3849V220.875L175.798 122.462V77.0774H130.413ZM58.9325 233.923V193.942H18.9524V233.923H58.9325Z'
                    fill='#EBEBEB'
                />

                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M239.635 58.625H311.115V130.105L188.845 252.375H117.365V180.895L239.635 58.625ZM247.278 77.0774L148.865 175.49H194.25V220.875L292.663 122.462V77.0774H247.278ZM175.797 233.923V193.942H135.817V233.923H175.797Z'
                    fill='#EBEBEB'
                />

                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M231.155 184.716L240.381 175.49H311.116V252.375H231.155V184.716ZM249.608 193.942V233.922H292.663V193.942H249.608Z'
                    fill='#EBEBEB'
                />
            </g>

            <defs>
                <clipPath id='clip0_1_748'>
                    <rect
                        width='310'
                        height='310'
                        fill='#EBEBEB'
                        transform='translate(0.5 0.5)'
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

export default LogoIcon
